import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = {
  key: 0,
  class: "modal-body__title"
}
const _hoisted_4 = {
  key: 1,
  class: "modal-body__desc"
}
const _hoisted_5 = { class: "modal-body__buttons" }

import { PropType } from 'vue';

import { TFunction } from '@/types/TFunction';


export default /*#__PURE__*/_defineComponent({
  __name: 'AiModal',
  props: {
  showModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  title: {
    type: String as PropType<string>,
    required: false,
  },
  description: {
    type: String as PropType<string>,
    required: false,
  },
  handleToggle: {
    type: Function as PropType<TFunction>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": props.showModal,
    "content-class": "modal-promocode__container",
    "onUpdate:modelValue": props.handleToggle,
    absolute: "",
    attach: ".app-template",
    scrim: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-background",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.handleToggle && props.handleToggle(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          (__props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.title), 1))
            : _createCommentVNode("", true),
          (__props.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.description), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "button")
          ])
        ])
      ])
    ]),
    _: 3
  }, 8, ["model-value", "onUpdate:modelValue"]))
}
}

})